import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Global axios config for auth cookies
axios.defaults.withCredentials = true;

// Bearer-token fallback for production environments where the ingress
// strips the Set-Cookie response header (Emergent K8s deployment). If a
// token is present in localStorage we attach it to every outgoing request;
// the backend already accepts either the cookie OR the Authorization header.
axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('trv_access_token');
    if (token && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {
    // localStorage unavailable (SSR / private browsing) — silently skip.
  }
  return config;
});

// Clear stored token on 401 so the user is forced to re-login rather than
// retrying forever with a stale/expired token.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try {
        localStorage.removeItem('trv_access_token');
        localStorage.removeItem('trv_refresh_token');
      } catch (_) { /* noop */ }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
